import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { NzSelectModule } from 'ng-zorro-antd/select';
import { CloseDropdownOnScrollModule } from '../../directives/close-dropdown-on-scroll/close-dropdown-on-scroll.module';

import { TimezoneControlComponent } from './timezone-control.component';



@NgModule({
  declarations: [TimezoneControlComponent],
  exports: [TimezoneControlComponent],
  imports: [
    CommonModule,
    NzSelectModule,
    CloseDropdownOnScrollModule,
    ReactiveFormsModule,
  ]
})
export class TimezoneControlModule { }
